import styled, { css } from "styled-components";
import { TextareaAutosize, } from "@material-ui/core";

const getBackgroundColorChip = (status) => {
  switch (status) {
    case "CONFIRM":
      return "#129768";
    case "EMPTY":
      return "#BDBDBD";
    case "MAYBE":
      return "#EF9952";
    case "REFUSE":
      return "#E11021";
    default:
      return "#002776";
  }
};

const getColorChip = (status) => {
  switch (status) {
    default:
      return "#ffffff";
  }
};

export const FilesContainer = styled.div`
  display: flex; 
  align-items: center;
  justify-content: center; 
  flex-direction: row;

  svg {
    margin-left: 8px;
    cursor: pointer;
  }
`;

export const Container = styled.div`
  display: flex;
  padding: 20px 40px;
`;

export const ContentForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const BoxQuorum = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
`;

export const BoxAction = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const BoxSuccess = styled.div`
  align-items: center;
  display: flex;
  background-color: #058328;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  height: 60px;
  justify-content: center;
  width: 100%;
`;

export const WrapperChip = styled.div`
  div {
    background-color: ${(props) => getBackgroundColorChip(props.status)};
    color: ${(props) => getColorChip(props.status)};
  }
  svg {
    color: ${(props) => getColorChip(props.status)};
  }
`;

export const Dropzone = styled.div`
  width: 100%;
  height: 100px;
  border: 2px dashed #000;
  margin-top: 26px;

  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: 18px;
    color: #465eb6;
    font-weight: bold;
  }
`;

export const FieldInfo = styled.span`
  font-size: 14px;
  color: #425AF4;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;
